import { Currency } from './currency';
import { Company } from './companies';
import { UnitOfMeasure} from './unit-of-measure';

export interface Tax {
  id: number;
  name: string;
  description?: string;
  taxType: string;
  fiscalValidity: string;
  invoiceTag: string;
  amount: number;
  amountType: string;
  companyId: number;
  isActive: boolean;
}

export interface ProductCompany extends Company {
  currencyId?: number;
  currency?: Currency;
  odooEntityId?: number;
}

export interface Product {
  id: number;
  name: string;
  defaultCode?: string;
  description?: string;
  productType?: string;
  unitPrice?: number;
  costPrice?: number;
  saleOk?: boolean;
  purchaseOk?: boolean;
  isActive?: boolean;
  companyId?: number | null;
  company?: ProductCompany;
  unitOfMeasureId?: number;
  unitOfMeasure?: UnitOfMeasure;
  unitOfMeasureIds?: number[];
  unitOfMeasures?: UnitOfMeasure[];
  taxes?: Tax[];
  supplierTaxes?: Tax[];
}

export interface ProductCreate {
  name: string;
  defaultCode?: string;
  description?: string;
  productType?: string;
  unitPrice?: number;
  costPrice?: number;
  saleOk?: boolean;
  purchaseOk?: boolean;
  isActive?: boolean;
  companyId?: number | null;
  unitOfMeasureId?: number;
  unitOfMeasureIds?: number[];
  taxIds?: number[];
  supplierTaxIds?: number[];
}

export interface ProductUpdate extends Partial<ProductCreate> {
  id: number;
}

export type ProductType = 'Good' | 'Service';
